export const arr = [
  {
    role: "LimsAdmin",
    url: "la",
  },
];
